<div *ngIf="burger === true">
  <a id="burger" [matMenuTriggerFor]="appMenu">
    <img src="assets/burger_INACTIVE.png"  alt="burger icon"/>
  </a>
  <mat-menu #appMenu="matMenu">
    <div *ngIf="!isInitialFormUser()" [matTooltip]="limitToScreeningProjects() ?
    ('ACCOUNT.PERMISSIONS.ACCESS_LIMITED_TO_SCREENING_PROJECTS' | anessaTranslation: trigger) : (
      isProjectLimitReached() ? ('ACCOUNT.PERMISSIONS.PROJECT_LIMIT_REACHED' | anessaTranslation: trigger) : null
    )">
      <button id="menu-new-project_button" mat-menu-item
              [ngClass]="{'disabled-button': limitToScreeningProjects() || isProjectLimitReached()}"
              [disabled]="limitToScreeningProjects() || isProjectLimitReached()"
              (click)="newProject()"
      >{{'DROPDOWN.NEW_PROJ' | anessaTranslation: trigger}}</button>
    </div>
    <button id="menu-open-project_button" mat-menu-item (click)="openProject()">{{'DROPDOWN.OPEN' | anessaTranslation: trigger}}</button>
    <div *ngIf="showNewInitialFormButton()" [matTooltip]="isScreeningProjectLimitReached()
      ? ('ACCOUNT.PERMISSIONS.SCREENING_PROJECT_LIMIT_REACHED' | anessaTranslation: trigger) : null">
      <button id="menu-init-form_button" mat-menu-item
              [ngClass]="{'disabled-button': isScreeningProjectLimitReached()}"
              [disabled]="isScreeningProjectLimitReached()"
              (click)="newInitialInformation()"
      >{{'DROPDOWN.NEW_INIT_FORM' | anessaTranslation: trigger}}</button>
    </div>
    <button id="menu-close-project_button" mat-menu-item *ngIf="isProjectLoaded()" (click)="closeProject()">{{'DROPDOWN.CLOSE' | anessaTranslation: trigger}}</button>
    <button id="menu-save-as_button" mat-menu-item *ngIf="isProjectLoaded() && !isInitialFormUser()" (click)="saveProjectAs()">{{'DROPDOWN.SAVE_AS' | anessaTranslation: trigger}}</button>
    <button id="menu-delete-project_button" mat-menu-item *ngIf="isProjectLoaded() && canDeleteProject()" (click)="deleteProject()">{{'DROPDOWN.DELETE' | anessaTranslation: trigger}}</button>
    <button id="menu-export_button" mat-menu-item *ngIf="isProjectLoaded() && isDBAdmin()" (click)="exportProject()">{{'DROPDOWN.EXPORT' | anessaTranslation: trigger}}</button>
    <!-- <button mat-menu-item *ngIf="isProjectLoaded()" (click)="printSummary()">{{'DROPDOWN.PRINT_SUM' | anessaTranslation: trigger}}</button> -->
    <button id="menu-reports_button" mat-menu-item *ngIf="isProjectLoaded() && !isInitialFormUser() && !isProjectInput()" [matMenuTriggerFor]="other">{{'DROPDOWN.REPORTS' | anessaTranslation: trigger}}</button>
    <button mat-menu-item *ngIf="!isInitialFormUser() && canViewArchived()" (click)="openArchived()">{{'DROPDOWN.ARCHIVED' | anessaTranslation: trigger}}</button>
  </mat-menu>
</div>

<mat-menu #other="matMenu">
  <button mat-menu-item *ngIf="isProjectLoaded()" (click)="printSummary()">{{'DROPDOWN.PRINT_SUM' | anessaTranslation: trigger}}</button>
  <!-- <button mat-menu-item *ngIf="isProjectLoaded()" (click)="onGenBasicReportClick()">{{'DROPDOWN.BASIC' | anessaTranslation: trigger}}</button>-->
  <!-- <button mat-menu-item *ngIf="isProjectLoaded()" (click)="onGenPremiumReportClick()">{{'DROPDOWN.PREMIUM' | anessaTranslation: trigger}}</button> -->
</mat-menu>


<div *ngIf="burger === false">
  <a id="user-name-box" [matMenuTriggerFor]="appMenu2">
    {{getName()}} <mat-icon>arrow_drop_down</mat-icon>
  </a>
  <mat-menu #appMenu2="matMenu">
    <button mat-menu-item *ngIf="isAccountAdmin()" (click)="showProfile()">{{'DROPDOWN.PROFILE' | anessaTranslation: trigger}}</button>

    <button mat-menu-item *ngIf="isAccountAdmin()" (click)="openAccountAdmin()">{{'DROPDOWN.ADMIN' | anessaTranslation: trigger}}</button>
    <button mat-menu-item (click)="openDefaultPreferences()">{{'DROPDOWN.USER_PREFERENCES.DEFAULT_PREFERENCES' | anessaTranslation: trigger}}</button>

    <!-- <button mat-menu-item *ngIf="canViewHelp()" (click)="openHelp()">{{'DROPDOWN.HELP' | anessaTranslation: trigger}}</button> -->
    <button mat-menu-item (click)="onLogout()">{{'DROPDOWN.LOGOUT' | anessaTranslation: trigger}}</button>
  </mat-menu>
</div>
